export default {
  loading: false,
  listLoading: false,
  records: [],
  total: 0,
  FilteredCount: 0,
  createLoading: false,
  record: {},
  /** Service State */
  serviceListLoading: false,
  serviceRecords: [],
  serviceTotal: 0,
  serviceFilteredCount: 0,
  /** FAQ State */
  faqListLoading: false,
  faqRecords: [],
  faqTotal: 0,
  faqFilteredCount: 0,
  /** Contact Us State */
  contactListLoading: false,
  contactRecords: [],
  contactTotal: 0,
  contactFilteredCount: 0,
  /** Contact Us State */
  dailyRoutineListLoading: false,
  dailyRoutineRecord: null,
  dailyRoutineTotal: 0,
  dailyRoutineFilteredCount: 0,
  /** Katha State */
  kathaListLoading: false,
  kathaRecords: [],
  kathaTotal: 0,
  kathaFilteredCount: 0,

  /** Ragi State */
  ragiListLoading: false,
  ragiRecords: [],
  ragiTotal: 0,
  ragiFilteredCount: 0,

  /** Donation State */
  donationListLoading: false,
  donationRecords: [],
  donationTotal: 0,
  donationFilteredCount: 0,

  /** Admin State */
  adminListLoading: false,
  adminRecords: [],
  adminTotal: 0,
  adminFilteredCount: 0,
  createAdminLoading: false,

  /** Valid Org Admin  */
  validAdminLoading: false,

  /** Organization Member */
  memberListLoading: false,
  memberRecords: [],
  memberTotal: 0,
  memberFilteredCount: 0,
  createMemberLoading: false,

  /** Update State */
  updateListLoading: false,
  updateRecords: [],
  updateTotal: 0,
  updateFilteredCount: 0
}
